export var single = [
  {
    "name": "ASU Digital Prep",
    "value": 8940000
  },
  // {
  //   "name": "USA",
  //   "value": 5000000
  // },
  // {
  //   "name": "France",
  //   "value": 7200000
  // }
];

export var multi = [
  {
    "name": "ASU Digital Prep",
    "series": [
      {
        "name": "2010",
        "value": 100000
      },
      {
        "name": "2011",
        "value": 125000
    },
    {
      "name": "2012",
      "value": 130000
    },
    {
      "name": "2013",
      "value": 150000
    },
    {
      "name": "2014",
      "value": 200000
    },
    {
      "name": "2015",
      "value": 180000
    },
    ]
  },
  //
  // {
  //   "name": "USA",
  //   "series": [
  //     {
  //       "name": "2010",
  //       "value": 7870000
  //     },
  //     {
  //       "name": "2011",
  //       "value": 8270000
  //     }
  //   ]
  // },
  //
  // {
  //   "name": "France",
  //   "series": [
  //     {
  //       "name": "2010",
  //       "value": 5000002
  //     },
  //     {
  //       "name": "2011",
  //       "value": 5800000
  //     }
  //   ]
  // }
];



// WEBPACK FOOTER //
// ./src/app/pages/d3graph/data.ts